import React, { useState } from "react";
import InputFieldsEmailTextPassword from "../common/InputFieldsEmailTextPassword";
import ButtonCommonComponent from "../common/ButtonCommonComponent";
import { useNavigate } from "react-router";
import { superAdminDashboard } from "../common/allLinks";

export default function AddNewAgencyDetailsLoginTabPanel({ handleOnSelect }) {
  const [values, setValues] = useState({
    username: "",
    password: "",
  });

  const navigate = useNavigate();

  /*===========================================
                handleOnChange
===========================================*/
  const handleOnChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(values);
    navigate({ pathname: superAdminDashboard });
  };

  /**==========================================================================  
                return
  ============================================================================ */
  return (
    <div className="client-dashboard-add-new-requirement-project-detaild-main-div">
      <div className="row mx-0 align-items-start flex-nowrap">
        <div className="col-6 ">
          <InputFieldsEmailTextPassword
            type="text"
            name="username"
            value={values.username}
            placeholder="For ex: TechM"
            onChange={handleOnChange}
            label="Admin Name"
          />
        </div>
        <div className="col-6">
          <InputFieldsEmailTextPassword
            type="password"
            name="password"
            value={values.password}
            placeholder="************"
            onChange={handleOnChange}
            label="Password"
          />
        </div>
      </div>

      <div className="text-center mt-50">
        <ButtonCommonComponent
          text="Save &amp; Create"
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
}
